var _g, _g2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDropdownArrowDown = function SvgDropdownArrowDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_19301",
    "data-name": "Group 19301",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow",
    transform: "translate(7.5 10.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10809",
    "data-name": "Path 10809",
    d: "M0,0H0L3.231,3.231",
    fill: "none",
    stroke: "#07a3c8",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1243",
    "data-name": "Line 1243",
    x2: 3.231,
    y2: 3.231,
    transform: "translate(6.462) rotate(90)",
    fill: "none",
    stroke: "#07a3c8",
    strokeLinecap: "round",
    strokeWidth: 1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "rectangle-3",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,0A11,11,0,0,1,22,11a11.171,11.171,0,0,1-2.277,6.7A10.84,10.84,0,0,1,11,22,11,11,0,0,1,11,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11 1 C 5.485979080200195 1 1 5.485979080200195 1 11 C 1 16.51401901245117 5.485979080200195 21 11 21 C 14.14671993255615 21 17.17895889282227 19.51150894165039 18.91518974304199 17.11293029785156 C 20.29857063293457 15.21407985687256 21 13.15738964080811 21 11 C 21 5.485979080200195 16.51401901245117 1 11 1 M 11 0 C 17.07513046264648 0 22 4.924869537353516 22 11 C 22 13.41182041168213 21.22380065917969 15.64235019683838 19.72344017028809 17.7017707824707 C 17.90838050842285 20.20925903320313 14.66331005096436 22 11 22 C 4.924869537353516 22 0 17.07513046264648 0 11 C 0 4.924869537353516 4.924869537353516 0 11 0 Z",
    stroke: "none",
    fill: "#07a3c8"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDropdownArrowDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dropdownArrowDown.08d17a67.svg";
export { ForwardRef as ReactComponent };